import React from 'react'
import { TbViewProvider } from '@vt/hooks'
import { useParams } from 'react-router-dom'
import { getQuery } from '@vt/utils'
import Content from '../areas/content'
import { BindProvider } from './BindProvider'

const Standard = () => {
  const { appId } = useParams()
  const { vid } = getQuery()

  return (
    <div className="w-full h-full">
      <BindProvider>
        <TbViewProvider appId={appId} tbId="standard" vid={vid}>
          <Content type="standard" />
        </TbViewProvider>
      </BindProvider>
    </div>
  )
}

export default Standard
